import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const currenciesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'code',
    label: 'Numeric code',
  },
  {
    name: 'name',
    label: 'Character code',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'decimals',
    label: 'Precesion',
  },
];

export const currenciesListColumnsLabels = {
  numericCode: 'Numeric code',
  name: 'Character code',
  description: 'Description',
};

export const currenciesListDefaultSorter = {};

export const currenciesListSchema = {
  numericCode: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  name: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  decimals: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const currenciesListFiltersSchema = [];
